import { useState } from "react";
import {
  FilterOptionProps,
  MapFilterTitle,
  MapSidebarFiltersProps,
} from "../../mapSidebar/mapSidebarFilters/mapSidebarFilters";

export type SidebarProps = {
  defaultDateRange?: string;
  defaultDropdownKey: string;
  availableTypes: string[];
};

export type ProfileMapFilters = Omit<
  MapSidebarFiltersProps,
  "dashboardMode" | "toggleDashboardMode"
>;
type ProfileMapFiltersHook = (sidebarProps: SidebarProps) => ProfileMapFilters;

const useProfileMapFilters: ProfileMapFiltersHook = (sidebarProps?) => {
  const filterOptions = generateFilterOptions(sidebarProps);

  const [currentFilters, setCurrentFilters] = useState(
    generateDefaultFiltersFromFilterOptions(filterOptions)
  );

  const onFiltersChange = (title: MapFilterTitle, value: string) => {
    setCurrentFilters({
      ...currentFilters,
      [title]: value,
    });
  };

  const onFiltersClear = () => {
    setCurrentFilters(generateDefaultFiltersFromFilterOptions(filterOptions));
  };

  return {
    filterOptions,
    currentFilters,
    onFiltersChange,
    onFiltersClear,
  };
};

export default useProfileMapFilters;

const generateFilterOptions = (props: SidebarProps): FilterOptionProps[] => {
  let result = [] as FilterOptionProps[];
  result = [generateDateRangeFilterOptions()];
  props?.availableTypes &&
    result.push({
      title: "KPI Type",
      defaultDropdownOption: props.defaultDropdownKey || "Showing All",
      dropdownOptions: [...props.availableTypes, "Showing All"],
    });
  return result;
};

const generateDateRangeFilterOptions = (): FilterOptionProps => {
  return {
    title: "Date Range",
    defaultDropdownOption: "All Time",
    dropdownOptions: [
      "Last 7 Days",
      "Last 30 Days",
      "Last 12 Weeks",
      "Last 6 Months",
      "Last 12 Months",
      "Year To Date",
      "All Time",
    ],
  };
};

const generateDefaultFiltersFromFilterOptions = (
  filterOptions: FilterOptionProps[]
) => {
  let filters = {} as MapSidebarFiltersProps["currentFilters"];
  for (let option of filterOptions) {
    filters[option.title] = option.defaultDropdownOption;
  }
  return filters;
};
